import { Component } from '@angular/core';

@Component({
  selector: 'taly-integration',
  templateUrl: './taly-integration.component.html',
  styleUrls: ['./taly-integration.component.scss'],
  standalone: false,
})
export class TalyIntegrationComponent {}
